export const NOTIFICATION_PERMISSIONS = {
    granted: 'granted',
    denied: 'denied',
    default: 'default',
};
